import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import overviewService from '../../services/overview.service';

export const getOverview = createAsyncThunk('dashboardSlice/getEnquiry', async (thunkAPI) => {
  try {
    const data = await overviewService.getOverviewAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const addOverview = createAsyncThunk('dashboardSlice/addOverview', async (params, thunkAPI) => {
  try {
    const data = await overviewService.addOverviewAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getOverviewList = createAsyncThunk('dashboardSlice/getOverviewList', async (thunkAPI) => {
  try {
    const data = await overviewService.getOverviewListAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const getPageDetailList = createAsyncThunk('dashboardSlice/getPageDetailList', async (thunkAPI) => {
  try {
    const data = await overviewService.getPageListingAPI();
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const addtoOverviewDetail = createAsyncThunk('dashboardSlice/addtoOverviewDetail', async (params, thunkAPI) => {
  try {
    const data = await overviewService.addtoOverviewListAPI(params);
    return data;
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  overviewList: [],
  detailOverviewList: [],
  pageDetailList: []
};

const overviewSlice = createSlice({
  name: 'overviewSlice',
  initialState,
  extraReducers: {
    [getOverview.fulfilled]: (state, action) => {
      state.overviewList = action.payload.data;
    },
    [getOverviewList.fulfilled]: (state, action) => {
      state.detailOverviewList = action.payload.data;
    },
    [getPageDetailList.fulfilled]: (state, action) => {
      state.pageDetailList = action.payload.data;
    }
  }
});

const { reducer } = overviewSlice;
export default reducer;
